import { render, staticRenderFns } from "./LinkScope.vue?vue&type=template&id=2d9a2878"
import script from "./LinkScope.vue?vue&type=script&lang=js"
export * from "./LinkScope.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports